import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import useCandidateOfferService from './candidateOfferService';
import { useListContext } from 'framework/list';
import { useNavigate, useParams } from 'react-router-dom';
import { useShowContext } from 'framework/show';
import { Tooltip } from 'framework/ui/mui-builder';
import { CANDIDATE_TIMELINE_OFFER_STATUSES, OFFER_OFFICES, useCandidateUrl } from 'domain/shared/candidate';

const TimelineOfferButtonGroup = ({ status, id }: any) => {
  const { cancelOffer, sendOffer, acceptOffer, rejectOffer } = useCandidateOfferService();
  const { reloadData } = useListContext();
  const navigate = useNavigate();
  const { getProfileUrl } = useCandidateUrl();
  const { candidateId } = useParams();
  const { data: offerData } = useShowContext();

  const office =
    offerData?.compensationDetails && offerData.compensationDetails[0] ? offerData.compensationDetails[0].office : null;
  const offerDocumentPath = offerData?.offerDocumentPath;

  const shouldShowGenerateOfferButton =
    office &&
    (office === OFFER_OFFICES.MINSK || office === OFFER_OFFICES.KRAKOW) &&
    status !== CANDIDATE_TIMELINE_OFFER_STATUSES.SENT;

  const onGetOffer = () => {
    navigate(`${getProfileUrl(candidateId)}/${id}/edit`);
  };

  const onCancelOffer = async () => {
    await cancelOffer(id);
    reloadData?.();
  };

  const onSentOffer = async () => {
    await sendOffer(id);
    reloadData?.();
  };

  const onAcceptOffer = async () => {
    await acceptOffer(id);
    reloadData?.();
  };

  const onRejectOffer = async () => {
    await rejectOffer(id);
    reloadData?.();
  };

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
        {status === CANDIDATE_TIMELINE_OFFER_STATUSES.DRAFT && (
          <>
            {shouldShowGenerateOfferButton && (
              <Button variant="outlined" sx={{ mr: 1 }} onClick={onGetOffer}>
                Get Offer
              </Button>
            )}
            <Button sx={{ backgroundColor: 'var(--mui-palette-text-secondary)', mr: 1 }} onClick={onCancelOffer}>
              Cancel
            </Button>
            <Tooltip
              title="In order to finalize offer, candidate's application must be moved to offer stage."
              placement="right"
            >
              <span>
                <Button disabled>Finalize</Button>
              </span>
            </Tooltip>
          </>
        )}
        {status === CANDIDATE_TIMELINE_OFFER_STATUSES.FINALIZED && (
          <>
            {shouldShowGenerateOfferButton && (
              <Button variant="outlined" sx={{ mr: 1 }} onClick={onGetOffer}>
                Get Offer
              </Button>
            )}
            <Button sx={{ backgroundColor: 'common.shadowContrast', mr: 1 }} onClick={onCancelOffer}>
              Cancel
            </Button>
            <Tooltip title={!offerDocumentPath && 'Generate the latest offer document before sending.'}>
              <span>
                <Button disabled={!offerDocumentPath} onClick={onSentOffer}>
                  Sent
                </Button>
              </span>
            </Tooltip>
          </>
        )}
        {status === CANDIDATE_TIMELINE_OFFER_STATUSES.SENT && (
          <>
            <Button sx={{ backgroundColor: 'common.shadowContrast', mr: 1 }} onClick={onCancelOffer}>
              Cancel
            </Button>
            <Button sx={{ backgroundColor: 'common.shadowContrast', mr: 1 }} onClick={onRejectOffer}>
              Reject
            </Button>
            <Button color="success" onClick={onAcceptOffer}>
              Accept
            </Button>
          </>
        )}
        {status === CANDIDATE_TIMELINE_OFFER_STATUSES.ACCEPTED && (
          <Button sx={{ backgroundColor: 'var(--mui-palette-text-secondary)', mr: 1 }} onClick={onRejectOffer}>
            Reject
          </Button>
        )}
      </Box>
    </>
  );
};

export default TimelineOfferButtonGroup;
